import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lib-tf-form-viewer',
  template: `
    <tf-core-fb-form-viewer
      [registrationId]="registrationId"
      [readonly]="readonly"
      (onClose)="onExit()"
    ></tf-core-fb-form-viewer>
  `,
  styles: [
  ]
})
export class TfFormViewerComponent {
  @Input() registrationId: string;
  @Input() readonly: boolean = false;

  @Output() onClose: EventEmitter<null> = new EventEmitter<null>();

  onExit() {
    this.onClose.emit();
  }
}
